import { Minus, Plus } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import { QuantitySelectorProps } from './QuantitySelector.types';

const buttonClassName =
  'px-3 py-4 disabled:text-line-strong disabled:bg-white dark:disabled:bg-transparent hover:bg-surface-muted active:bg-line';

export const QuantitySelector = ({
  value,
  minimumValue = 1,
  microcopy,
  className = '',
  onDecreaseQuantity,
  onIncreaseQuantity,
}: QuantitySelectorProps) => {
  return (
    <div
      className={c(
        'flex w-fit rounded-lg border border-line-strong text-content',
        className
      )}
    >
      <button
        type="button"
        className={c(buttonClassName, 'rounded-l-lg')}
        aria-label={microcopy.decreaseQuantityAriaLabel}
        disabled={value <= minimumValue}
        onClick={onDecreaseQuantity}
      >
        <Minus className="h-4 w-4" />
      </button>
      <span
        className="w-10 py-4 text-center text-sm font-bold leading-5 tracking-[-0.028px]"
        data-testid="quantity-value"
      >
        {value}
      </span>
      <button
        type="button"
        className={c(buttonClassName, 'rounded-r-lg')}
        aria-label={microcopy.increaseQuantityAriaLabel}
        onClick={onIncreaseQuantity}
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
};
